import React, {PropsWithChildren} from 'react';

import {ToggleColorMode} from '../shared/contexts/colorModeContext';

export const LoginpageProviderLayout: React.FC<PropsWithChildren> = ({
  children,
}) => {
  return <ToggleColorMode active={false}>{children}</ToggleColorMode>;
};
